import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'

import LeadsReport from '@/components/reports/LeadsReport.vue'

import { CHANNEL_REPORTS } from './websiteReport'


export default {
  __name: 'WebsiteChannelReport',
  setup(__props) {

const route = useRoute()
const agentId = computed(() => route.params.id)
const channel = computed(() => route.params.channel)
const meta = computed(() => CHANNEL_REPORTS[channel.value] ?? CHANNEL_REPORTS.form)
const channelName = computed(() => meta.value.name.toLowerCase())

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(LeadsReport, {
    title: meta.value.title,
    endpoint: `agents/${agentId.value}/website/report`,
    params: { channel: channel.value },
    "download-type": meta.value.downloadType,
    "download-params": { agent_id: agentId.value },
    description: `Inquiries from your ${channelName.value} and the orders your agent took from them.`,
    "empty-text": `No inquiries from your ${channelName.value} in this date range yet.`
  }, null, 8, ["title", "endpoint", "params", "download-type", "download-params", "description", "empty-text"]))
}
}

}